<template>
  <div>
    <div class="right">
      <div class="top">
        <router-link class="login" to="/login"
          ><img
            src="../assets/images/icon-login-green.svg"
            alt="icone login"
          />{{ alreadyAccount }}</router-link
        >
        <h1>{{ titleForm }}</h1>
      </div>

      <!-- <div class="social">
        <a href="#" class="fb bt-social">
          <img src="../assets/images/facebook.svg" alt="facebook" />
          <span>Facebook</span>
        </a>
        <a href="#" class="google bt-social">
          <img src="../assets/images/google.svg" alt="google" />
          <span>Google</span>
        </a>
        <a href="#" class="twitter bt-social">
                    <img src="../assets/images/linkedin.svg" alt="facebook">
                    <span>Linkedin</span>
                </a>
      </div> -->

      <form
        @submit.prevent="createAccount"
        action=""
        id="form-cadastro"
        class="form"
      >
        <div class="form-group">
          <label for="nome">Nome Completo</label>
          <input v-model="newAccount.fullname" type="text" name="firstname" class="js-input" :class="{ 'error': hasError.name }" @focusout="validateName" id="nome" />
        </div>
        <div class="form-group">
          <label for="email">E-mail</label>
          <input v-on:focusout="isEmailDeliverable" v-model="newAccount.email" type="email" name="email" class="js-input" :class="{ 'error': hasError.email }"  @focusout="validateEmail" id="email" />
        </div>
        <!-- <div class="form-group">
          <label for="telefone">Telefone</label>
          <input
            v-model="newAccount.tel"
            type="text"
            name="telefone"
            mask="phone"
            class="js-input"
            id="telefone"
          />
        </div> -->
        <div class="form-group">
          <label for="senha">Senha</label>
          <input
            v-model="newAccount.password"
            type="password"
            name="senha"
            class="js-input password"
            :class="{ 'error': hasError.password }" 
            @focusout="validatePassword"
            id="senha"
            onmouseover="this.type='text'"
            onmouseout="this.type='password'"
          />
          <div class="icon">
            <img src="../assets/images/olho-green.svg" alt="icone senha" />
          </div>
        </div>
        <div class="form-group terms">
          <div class="checkboxContainer">
            <input class="form-check-input" type="checkbox" id="termo" name="termo" v-model="allowTerms">
            <span class="checkmark"></span>
          </div>
          <label for="termo"
            >Li e concordo com os
            <a href="https://iouu.com.br/termos" target="_blank" class="term"
              >termos e condições</a
            >
            e
            <a
              href="https://iouu.com.br/politica-de-privacidade/"
              class="condition"
              target="_blank"
              >política de privacidade</a
            >
            da IOUU.
          </label>
        </div>
        <div class="form-group">
          <button class="btn" type="submit" :disabled="disable">
            Comece a investir melhor
            <img src="../assets/images/icon-arrow-right.svg" alt="icone seta" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import HubConsultaClient from '@/utils/hub-consulta-client.js';
import * as mutationTypes from '@/store/mutation-types.js'

export default {
  data() {
    return {
      alreadyAccount: "Já tenho uma conta",
      titleForm:
        "Inicie seu cadastro para ver as oportunidades de investimento",
      newAccount: {
        fullname: "",
        email: "",
        tel: "",
        password: "",
      },
      allowTerms: false,
      emailDeliverable: false,
      hasError: {
        name: false,
        email: false,
        password: false,
      },
      disable: false
    };
  },
  methods: {
    async createAccount() {
      this.disable = true;
      this.$store.commit(mutationTypes.START_LOADING);
      const valid = await this.validadeFields();
      if(valid) this.$emit('newAccount', this.newAccount);
      this.$store.commit(mutationTypes.STOP_LOADING);
    },
    validadeFields() {

      if(!this.validateName()) return;
      if(!this.validateEmail()) return;
      if(!this.validatePassword()) return;
      
      const validEmail = this.emailDeliverable;
      if(!validEmail) {
        this.hasError.email = true;
        this.$Notify.error('O e-mail informado é inválido!');
        return false;
      }

      const aggredTerms = this.allowTerms;
      if(!aggredTerms) this.$Notify.error('É necessário concordar com os termos de uso para continuar o cadastro!');

      return validEmail && aggredTerms;
    },

    validateName() {
      const { fullname } = this.newAccount;
      const hasName = fullname.trim().length > 0;
      const isFullName = fullname.split(' ')[1] ? fullname.split(' ')[1].length > 1 : false;

      if(!hasName) {
        this.hasError.name = true;
        this.$Notify.error('É necessário informar o nome completo!');
        return false;
      }

      if(!isFullName) {
        this.hasError.name = true;
        this.$Notify.error('É necessário informar o nome completo!');
        return false;
      }

      this.hasError.name = false;
      return true;
    },

    validateEmail() {
      const { email } = this.newAccount;
      const hasEmail = email.trim().length > 0;
      const hasEmailBody = email.includes("@");
      
      if(!hasEmail) {
        this.hasError.email = true;
        this.$Notify.error('Campo de email é obrigatório!');
        return false;
      }

      if(!hasEmailBody) {
        this.hasError.email = true;
        this.$Notify.error('Campo de email está no formato incorreto!');
        return false;
      }


      this.hasError.email = false;
      return true;
    },

    validatePassword() {
      const { password } = this.newAccount;
      const hasPassword = password.trim().length >= 6;

      if(!hasPassword) {
        this.hasError.password = true;
        this.$Notify.error('O campo de senha deve conter pelo menos 6 dígitos!');
        return false;
      }

      this.hasError.password = false;
      return true;
    },

    async isEmailDeliverable() {
      const email = this.newAccount.email;
      HubConsultaClient.theCheckerPost(email)
       .then(resposta => {
          if(resposta == "Entregável") {
            this.$Notify.info('Email validado com sucesso!')
            this.emailDeliverable = true;
          } else {
            this.hasError.email = true;
            this.emailDeliverable = false;
            this.$Notify.error('Email informado é inválido!');
          }
        })
        .catch((resposta) => {
          // Para eventuais problemas no HUB ou THE CHECKER, o email sempre será validado
          console.log("RESPOSTA ERRO: " + resposta)
          this.emailDeliverable = true;
        
        });
    },
    
    videoask() {
      window.VIDEOASK_EMBED_CONFIG = {
        "kind": "widget",
        "url": "https://www.videoask.com/fwvmh15n8",
        "options": {
          "widgetType": "VideoThumbnailWindowTall",
          "text": "Olá, bem vindo(a)! 👋",
          "backgroundColor": "#00D9C5",
          "position": "bottom-right"
        }
      }
      var script = document.createElement("script");
      script.src = "https://www.videoask.com/embed/embed.js";
      document.getElementsByTagName("body")[0].appendChild(script);
    }
  },

  created() {
    this.videoask();
  },
};
</script>

<style lang="scss" scoped>
$verde: #41d3bd;
$azul: #21247f;
$azul-sec: #3b46c4;
$branco: #ffffff;
$cinza-claro: #e9eafa;
$cinza-medio: #818495;
$cinza-escuro: #2c3236;

.form {
  display: flex;
  flex-direction: column;

  .form-group {
    position: relative;
    margin-bottom: 26px;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;

    &:last-child {
      margin-bottom: 0;
    }
    &.focus {
      label {
        font-size: 12px;
        top: 12px;
        transition: all 0.3s;
      }
    }
    label {
      font-size: 0.875rem;
      line-height: 150%;
      letter-spacing: 0.01em;
      font-weight: normal;
      color: #616e8e;
      position: absolute;
      top: -11px;
      left: 18px;
      pointer-events: none;
      transition: all 0.3s;
      background-color: $branco;
      padding: 0 6px;
      &.error {
        position: relative;
        top: 0;
        left: 0;
        font-size: 13px;
        margin-top: 10px;
        margin-left: 5px;
        color: $cinza-escuro;
      }
    }

    input[type="text"],
    input[type="email"],
    input[type="password"] {
      width: 100%;
      border: 1px solid rgba(97, 110, 142, 0.2);
      height: 52px;
      border-radius: 4px;
      background: transparent;
      font-size: 0.875rem;
      line-height: 150%;
      letter-spacing: 0.01em;
      color: #616e8e;
      padding: 0px 18px;
      &.error {
        border: 1px solid red !important;
      }
    }
    .btn {
      width: 238px;
      height: 64px;
      background-color: $verde;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      span {
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        font-weight: bold;
        font-size: 1.125rem;
        line-height: 135%;
        letter-spacing: 0.005em;
        color: $branco;
      }

      img {
        margin-left: 22px;
      }

      &:hover {
        transition: all 0.3s;
        background-color: $azul;
      }
    }
  }
}

.right {
  .top {
    margin-bottom: 36px;
    .login {
      margin-bottom: 34px;
      display: flex;
      color: $azul;
      transition: all 0.3s;
      img {
        margin-right: 16px;
      }
      &:hover {
        transition: all 0.3s;
        color: $verde;
      }
    }
    h1 {
      margin-bottom: 24px;
    }
  }

  .social {
    margin-bottom: 51px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    a {
      width: 32%;
      flex: 1;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $cinza-claro;
      border: 1px solid $cinza-claro;
      border-radius: 4px;
      transition: all 0.3s;
      margin-right: 15px;

      span {
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 130%;
        letter-spacing: 0.01em;
        color: $azul;
      }
      img {
        margin-right: 10px;
      }
      &:hover {
        transition: all 0.3s;
        border: 1px solid $azul;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;

    .form-group {
      .btn {
        width: 386px;
        height: 59px;
        color: $branco;
      }
      &:nth-child(4) {
        margin-bottom: 47px;
        flex-direction: row;
        justify-content: flex-start;

        span {
          max-width: 378px;
          position: relative;
          font-size: 14px;
          line-height: 150%;
          letter-spacing: 0.01em;
          color: $cinza-medio;
        }

        input[type="checkbox"] {
          border: 1px solid #818495;
          width: 24px;
          height: 24px;
          cursor: pointer;
          position: relative;
          background: #00D9C5;
        }

        // CHECKBOX - CUSTOM 
      .checkboxContainer {
        &{
          display: block;
          position: relative;
          cursor: pointer;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          width: 15px;
          height: 15px;
          margin-right: 10px;
        }
        
        &:hover {
          input ~ .checkmark {
          background-color: #ccc;
          }
        }
      
        input {
          position: absolute !important;
          opacity: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          left: 0;
          margin-left: 0;
          top: -4px;
      
          &:checked ~ .checkmark {
          background-color: #41D3BF;
          }
        }
      
        .checkmark {
          position: absolute;
          top: -4px;
          left: 0;
          height: 25px;
          width: 25px;
          background-color: #eee;
          border-radius: 6px;
          cursor: pointer;
          pointer-events: none;
      
          &::after {
          content: "";
          position: absolute;
          display: none;
          width: 8px;
          height: 13px;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
          }
      
        }
      
        input:checked ~ .checkmark:after {
          display: block;
        }
      }
      // END CHECKBOX - CUSTOM
    }
      .icon {
        height: 100%;
        width: 64px;
        z-index: 3;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.octa-widget-v2 {
  display: none;
}

.terms {
  align-items: center !important;
  label {
    pointer-events: auto !important;
    position: inherit !important;
    top: 0 !important;
    margin-bottom: 0 !important;
    cursor: pointer;
    a:hover {
      text-decoration: underline !important;
    }
  }
}

@media (max-width: 1199px) {
  .right {
    .nav {
      display: none;
    }
  }
}

@media (max-width: 1050px) {
  .right {
    width: 509px;

    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      .login {
        margin-bottom: 24px !important;
      }
      h1 {
        text-align: center;
        font-size: 2rem;
      }
    }
    .form {
      .form-group {
        &:last-child {
          align-items: center;
        }
      }
    }
  }
}

@media (max-width: 560px) {
  .right {
    width: 100%;

    .social {
      a {
        span {
          display: none;
        }
      }
    }
    .form {
      .form-group {
        .btn {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationScreenForm.vue